import { useEffect, useState } from "react";

import { Tab } from "@headlessui/react";

import { scrollToBottomHeader } from "common/action-function/scrollToBottomHeader";

import Title from "components/atoms/Title/index";
import TabListNew from "components/molecules/TabListNew/index";

import CardDesktop from "./CardDesktop";
import CardPackageMobile from "./CardMobile";

/**
 *
 * @param {{
 * title: String;
 * description:String;
 * }} props Props for the component
 *
 */
const SGPackage = (props) => {
  const { title, description, listPackage, data, reverse, note } = props;

  const cardDarkList = listPackage.filter((item) => item.card_type === "dark");
  const cardLightList = listPackage.filter(
    (item) => item.card_type === "light"
  );
  const dataFromAPI = data?.dataPackage;
  const dataEntitySuffix = dataFromAPI?.entitySuffix?.EntityTypes;
  const dataPackage = dataFromAPI.packages;

  const [defaultTab, setDefaultTab] = useState(0);

  const temp = dataEntitySuffix?.reduce((totalID, currentValue) => {
    totalID.push(`${currentValue.guid}-package`);

    return totalID;
  }, []);

  const dataLink = `${dataEntitySuffix[0]?.guid}-package`;

  useEffect(() => {
    if (dataLink.length > 0) {
      const url = window.location.href;

      setDefaultTab(
        temp.indexOf(url.split("#")[1]) < 0
          ? 0
          : temp.indexOf(url.split("#")[1])
      );
      if (url.search(`#${url.split("#")[1]}`) > 0) {
        const scrollToTable = document.getElementById("PriceTable");

        scrollToBottomHeader(scrollToTable);
      }
    }
  }, []);

  useEffect(() => {
    if (dataLink.length == 0) {
      setDefaultTab(0);
    }
  }, []);
  const checkLengthContent = dataEntitySuffix
    ?.map((item) => item.name)
    .join(" ").length;
  const countryId = dataFromAPI?.entitySuffix?.id;

  return (
    <div id="PriceTable">
      {title && (
        <Title
          text={title}
          className={`bbc-title text-center ${
            description && description.length ? " mb-6" : " mb-6 lg:mb-10"
          }`}
        />
      )}
      {description && <p>{description}</p>}
      <TabListNew
        activeTab={defaultTab}
        data={dataEntitySuffix?.map((item) => item.name)}
        tabLinks={dataEntitySuffix?.map((item) => `${item.guid}-package`)}
        tabListClass={{
          ...(checkLengthContent > 30 && {
            display: "block md:flex justify-center",
            border: "border-0 md:border border-bbc-neutral-600",
            background: "bg-transparent md:bg-white",
          }),
          othersClass: "md:whitespace-nowrap ",
        }}
        tabClass={{
          tabColor:
            " text-bbc-neutral-600 hover:text-bbc-brand-500 border-bbc-neutral-600 md:border-transparent mx-auto",
          tabColorActive: "text-bbc-brand-500 border-bbc-brand-500 bg-white",
          ...(checkLengthContent > 30 && {
            othersClass: "my-1 md:my-0  mx-auto",
          }),
        }}
      >
        <Tab.Panels className="mt-6 w-full ">
          {dataFromAPI.entitySuffix?.EntityTypes?.map((entity, indexEntity) => {
            const EntityFilterPackage = dataPackage.filter(
              (item) => item.EntityType.id === entity.id
            );

            const filterByCardType = (cardArray) => {
              const filterStaticCardData = cardArray.find(
                (item) => item.entityTypeId === entity.id
              );
              const filterDynamicCardData = EntityFilterPackage.find(
                (item) => item.id === filterStaticCardData.id
              );

              const mergeData = {
                ...filterStaticCardData,
                ...filterDynamicCardData,
              };

              const price = mergeData?.Services?.reduce(
                (sum, item) => sum + item?.Fee?.value,
                0
              );
              const discount = mergeData?.Services?.reduce((sum, item) => {
                if (item.service_type_id === 49) {
                  return sum + item?.Fee?.value;
                }

                return sum;
              }, 0);
              const renewal_fee =
                dataFromAPI.dataRenewal
                  .find((item) => item.mapping_package_id === mergeData.id)
                  ?.Services?.reduce(
                    (sum, item) => sum + item?.Fee?.value,
                    0
                  ) || 0;

              return {
                ...filterStaticCardData,
                ...filterDynamicCardData,
                price,
                countryId,
                ...(discount != 0 && { sale_off: Math.abs(discount) }),
                ...(renewal_fee != 0 && { renewal_fee: Math.abs(renewal_fee) }),
                name: mergeData.PackageType.name,
              };
            };
            const cardDark = filterByCardType(cardDarkList);
            const cardLight = filterByCardType(cardLightList);
            const dataAll = [cardDark, cardLight];

            return (
              <Tab.Panel
                className="focus:outline-none focus:outline-0 focus:ring-0"
                as="div"
                key={`${indexEntity}-mb`}
              >
                <div className="hidden grid-flow-row  gap-y-10 lg:grid ">
                  {cardDark && (
                    <div
                      id={cardDark.el_id}
                      {...(reverse && { className: "order-1" })}
                    >
                      <CardDesktop
                        dataPackage={dataFromAPI}
                        indexEntity={indexEntity}
                        {...cardDark}
                      />
                    </div>
                  )}
                  {cardLight && (
                    <div id={cardLight.el_id}>
                      <CardDesktop
                        dataPackage={dataFromAPI}
                        indexEntity={indexEntity}
                        {...cardLight}
                      />
                    </div>
                  )}
                </div>
                <div className="block w-full lg:hidden">
                  {listPackage &&
                    listPackage.map((item) => (
                      <div
                        key={`${item.el_id}-mobile`}
                        id={`${item.el_id}-mobile`}
                      >
                        <CardPackageMobile
                          data={{
                            ...item,
                            ...dataAll.find((pack) => pack.id === item.id),
                          }}
                          linkRegister={`/onboarding/register?country_id=${countryId}&entity_type_id=${entity.id}&package_id=${item.id}`}
                          dataPackage={dataFromAPI}
                          indexEntity={indexEntity}
                        />
                      </div>
                    ))}
                </div>
              </Tab.Panel>
            );
          })}
        </Tab.Panels>
      </TabListNew>
      {note && (
        <i
          className="mt-6 block rounded-2xl bg-[#F5F5F5] px-4 py-6 text-sm leading-6 lg:mt-10 lg:px-10"
          dangerouslySetInnerHTML={{ __html: note }}
        />
      )}
    </div>
  );
};

export default SGPackage;
